module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3Curve',
        symbol: '3Crv',
    },
    assets: 'DAI+USDT+BUSD',
    addresses: {
        swap: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        lpToken: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        gauge: '0xe49e0601b83590e0b323dc2fc87bb568d7cd5eb9',
    },
    hasNoGauge: true,
}];
